import { Icon } from '@mui/material';
import React, { CSSProperties, type ReactElement } from 'react';

import './style.scss';

interface ModalComponentProps {
  showModal: boolean;
  closeModal: () => void;
  children: React.ReactNode;
  contentStyle?: CSSProperties;
  provideContainer?: boolean;
}

export function ModalComponent({
  showModal,
  closeModal,
  children,
  contentStyle = {},
  provideContainer = true
}: ModalComponentProps): ReactElement {
  const display = showModal ? 'flex' : 'none';

  return (
    <div className="modal-container" style={{ display }}>
      <div className="modal-veil" onClick={closeModal} />

      {
        provideContainer ?
          <div className="modal-content" style={contentStyle}>
            <div className="modal-close-icon" onClick={closeModal}>
              <Icon>close_sharp</Icon>
            </div>
            { showModal && children }
          </div>
          :
          <>{children}</>
      }
    </div>
  );
}

export default ModalComponent;
